













import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { IEpic, IJWT } from '@/lib/interfaces';
import { EIssueStatus, ERole } from '../../lib/enums';

@Component
export default class IssueStatusSelect extends Vue {
  @Model('change') private value!: EIssueStatus;

  private onChange(newVal: EIssueStatus): void {
    this.$emit('change', newVal);
  }

  private get statuses(): EIssueStatus[] {
    const allStatuses: EIssueStatus[] = Object.values(EIssueStatus);
    if (!this.checkRoles([ERole.project_manager, ERole.project_owner])) {
      allStatuses.filter((status) => status !== EIssueStatus.Done);
    }
    return allStatuses;
  }

  private checkRoles(roles: ERole[]): boolean {
    const user = this.$store.state.currentUser as IJWT;
    return roles.some((role) => user.roles.includes(role));
  }
}
